/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_messenger",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "NotCrossChainCall",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "messageId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "msgValue",
                type: "uint256",
            },
        ],
        name: "ReceivedMessage",
        type: "event",
    },
    {
        inputs: [],
        name: "PACKAGE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "VERIFIED_MASK_INDEX",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "authorizedHook",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "message",
                type: "bytes",
            },
        ],
        name: "isVerified",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "moduleType",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "portal",
        outputs: [
            {
                internalType: "contract IOptimismPortal",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "messageId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "msgValue",
                type: "uint256",
            },
        ],
        name: "preVerifyMessage",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "message",
                type: "bytes",
            },
        ],
        name: "releaseValueToRecipient",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_hook",
                type: "bytes32",
            },
        ],
        name: "setAuthorizedHook",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "verifiedMessages",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "message",
                type: "bytes",
            },
        ],
        name: "verify",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class OPL2ToL1Ism__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_messenger, overrides) {
        return super.deploy(_messenger, overrides || {});
    }
    getDeployTransaction(_messenger, overrides) {
        return super.getDeployTransaction(_messenger, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
//# sourceMappingURL=OPL2ToL1Ism__factory.js.map